<template>
  <b-container class="px-0" fluid>
    <b-col class="px-2" style="display: flex; flex-direction: row-reverse;">
      <b-row align-h="end" class="col-lg-6 col-12 pl-0">
        <origin-filter>
          <v-select
            id="sales-products-origin-selector"
            slot="options"
            class="origin-selector col"
            :clearable="false"
            v-model="salesProductsOriginSelected"
            :options="site_or_order_origin"
            @input="updateSalesProductsContext()"/>
        </origin-filter>
      </b-row>
    </b-col>
  </b-container>
</template>

<script>
import OriginFilter from '@/components/OriginFilter.vue'

export default {
  mounted() {
    this.salesProductsOriginSelected.code = this.$store.getters.salesProductsOriginSelectedCode
    this.salesProductsOriginSelected.label = this.site_or_order_origin[this.salesProductsSiteOriginSelectedIndex]
      ? this.site_or_order_origin[this.salesProductsSiteOriginSelectedIndex].label
      : 'Todas as origens'
  },
  components: {
    OriginFilter
  },
  data: () => ({
    salesProductsOriginSelected: {
      code: null,
      label: null
    },
  }),
  computed: {
    site_or_order_origin() { return this.$store.getters.site_or_order_origin },

    salesProductsSiteOriginSelectedIndex() { return this.$store.getters.salesProductsSiteOriginSelectedIndex },
    salesProductsSiteOriginText() { return this.site_or_order_origin[this.salesProductsSiteOriginSelectedIndex].label }  // Esse cara usa index de lista
  },
  methods: {
    updateSalesProductsContext() {
      this.$store.commit('updateSalesProductsSiteOriginSelectedIndex', this.salesProductsOriginSelected.code);
      this.$store.commit('updateCommonContext', {
        'url': 'order/dashboard/order_sales_products_context/',
        'payload': { 'site_or_order_origin': this.salesProductsOriginSelected.site_or_origin }
      });
      this.$store.commit('updateSalesProductsOriginSelectedCode', this.salesProductsOriginSelected.code)
    }
  }
}
</script>

<style>
  @media only screen and (max-width: 576px) {
    .small-media-justify-center {
      margin-top: 0.5rem;
    }
  }
</style>
